import { gql } from '@apollo/client';

export * from './clientChangesRequested.query.generated';

export const CLIENT_CHANGES_REQUESTED = gql`
  query clientChangesRequested {
    clientChangesRequested @client {
      isRequested
      depositor {
        id
        payload
        status
        creator
        receiver
      }
      beneficiary {
        id
        payload
        status
        creator
        receiver
      }
      deposits {
        id
        payload
        status
        creator
        receiver
      }
      notifications {
        id
        payload
        status
        creator
        receiver
      }
      agreement {
        id
        payload
        status
        creator
        receiver
      }
      environment {
        id
        payload
        status
        creator
        receiver
      }
    }
  }
`;
